"use strict";
import {onFind} from "@elements/init-modules-in-scope";
import {findAll, findIn, on, addClass, removeClass} from "@elements/dom-utils";

const isMobile = () => matchMedia('(max-width: 767px)').matches;

export function init() {
    onFind(".js-circle-teaser", function (teaser) {
        let items = findAll(".js-circle-teaser__item", teaser);
        let titles = findAll(".js-circle-teaser__title", teaser);
        let svgElement = findIn('.js-circle-teaser__line', teaser);
        let circleTitle = findIn('.js-circle-teaser__circle-title', teaser);

        items.map((item) => {
            on('click', function(evt) {
                let title = findIn('.js-circle-teaser__title', item);
                titles.map((title) => {
                    removeClass('is-active', title);
                });
                items.map((item) => {
                    removeClass('is-active', item);
                });
                addClass('is-active', title);
                addClass('is-active', item);
                if(!isMobile()) {
                    drawLine();
                }
            }, item);
        });

        function drawLine() {
            if (!circleTitle || !svgElement) return;

            let activeItem = findIn('.js-circle-teaser__title.is-active', teaser);
            if (!activeItem) return;

            let titleRect = circleTitle.getBoundingClientRect();
            let listItemRect = activeItem.getBoundingClientRect();
            let teaserRect = teaser.getBoundingClientRect();

            let startX = titleRect.left + titleRect.width / 2 - teaserRect.left;
            let startY = titleRect.top + titleRect.height / 2 - teaserRect.top;
            let endX = listItemRect.left - teaserRect.left;
            let endY = listItemRect.bottom - teaserRect.top;

            svgElement.innerHTML = ''; // Clear previous lines

            let line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
            line.setAttribute('x1', startX);
            line.setAttribute('y1', startY);
            line.setAttribute('x2', endX);
            line.setAttribute('y2', endY);
            line.setAttribute('stroke', '#7F7F7F');
            line.setAttribute('stroke-width', '1');

            svgElement.appendChild(line);
        }

        if(!isMobile()) {
            drawLine();
        }
    });
}